import * as angular from "angular";
import {Preference} from "../../models/preference.model";
import {ApiUrl} from "../../models/app-config.model";
import {UserService} from "../user/user.service";
import {CurrentUser} from "../../models/user/user.model";

interface PreferenceResponse { data: Preference; }

export interface PreferenceObject {
    userId?: string;
    [preference: string]: string | boolean;
}

export interface PreferenceService {
    getInstitutionPreference: (tenantId: string) => angular.IPromise<Preference>;
    setUserPreference: (preference: PreferenceObject) => angular.IPromise<number>;
}

/* @ngInject */
export function preferenceService(API_URL: ApiUrl, $http: angular.IHttpService,
                                  $q: angular.IQService,
                                  userService: UserService): PreferenceService {
    return {
        getInstitutionPreference: (tenantId: string): angular.IPromise<Preference> => {
            return $http.get(`${API_URL.preference.replace(/:tenantId/, tenantId)}`)
                .then((response: PreferenceResponse) => response.data)
                .catch((errorResponse) => {
                    if (errorResponse.status === 404) {
                        console.log('Handling 404 and returning...');
                        return {};
                    } else {
                        console.log('Rejecting with error:', errorResponse);
                        return $q.reject(errorResponse);
                    }
                });
        },
        setUserPreference: (preference: PreferenceObject): angular.IPromise<number> => {
            return userService.get().then((currentUser: CurrentUser) => {
                preference.userId = currentUser.userId;
                return $http.post(`${API_URL.updateUserPreferences}`, preference)
                    .then((response) => response.status);
            });
        }
    };
}



/** WEBPACK FOOTER **
 ** ./~/tslint-loader!./app/common/preference/preference.service.ts
 **/